export class EmployeeValidateStatus {
    id: number;
    count: number;
    emailSend: number;
    isConfirmed: number;
    procentage: number;
}